// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_ONBOARD = "/onboarding";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_RESPS = "/representative";
const ROOTS_NEWSFEED = "/newsfeed";
const ROOTS_MESSAGES = "/messages";
const ROOTS_ACCOUNT = "/account";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  signIn: path(ROOTS_AUTH, "/sign-in"),
  signUp: path(ROOTS_AUTH, "/sign-up"),
  otp: path(ROOTS_AUTH, "/otp-code"),
  reset: path(ROOTS_AUTH, "/forgot-password"),
};

export const PATH_ONBOARD = {
  root: ROOTS_ONBOARD,
  account: path(ROOTS_ONBOARD, "/account"),
};
export const PATH_REPS = {
  root: ROOTS_RESPS,
};
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  post: path(ROOTS_DASHBOARD, "/post"),
  reps: path(ROOTS_DASHBOARD, "/representative"),
};
export const PATH_NEWSFEED = {
  root: ROOTS_NEWSFEED,
};
export const PATH_MESSAGES = {
  root: ROOTS_MESSAGES,
};
export const PATH_ACCOUNT = {
  root: ROOTS_ACCOUNT,
  edit: path(ROOTS_ACCOUNT, "/edit"),
  faq: path(ROOTS_ACCOUNT, "/faq"),
  terms: path(ROOTS_ACCOUNT, "/terms"),
  privacy: path(ROOTS_ACCOUNT, "/privacy"),
};
